import { stateGo } from 'redux-ui-router';
import { fetchRecipe, recipePrintUri, selectRecipe } from 'logic/recipe';

import {
  mapIsFavouriteRecipes,
  selectFavouriteRecipeIds,
  toggleFavouriteRecipe,
} from 'logic/favourite';

import {
  fetchMember,
  selectMember,
  selectSubscription,
  selectPrintTooltip,
} from 'logic/member';

export const Recipe = {
  transclude: {
    navLeft: '?recipeNavLeft',
  },

  template: `
    <div class="recipe">
      <nav-page>
        <nav-left ng-transclude="navLeft"></nav-left>
        <nav-right>
          <button-print
            uri="{{ $ctrl.printUri }}"
            tooltip="$ctrl.tooltip"
            ng-click="$ctrl.refetchMember()"
            ng-if="$ctrl.subscription.canPrint">
          </button-print>
        </nav-right>
      </nav-page>
      <main class="main-content">
        <div class="container">
          <header class="pt-4 pb-3">
            <h2 class="mb-0">
              {{ $ctrl.recipe.name }}
            </h2>
          </header>
          <div class="pb-5">
            <recipe-detail
              recipe="$ctrl.recipe"
              is-favourite="$ctrl.recipe.isFavourite"
              on-click-variation="$ctrl.stateGo($ctrl.name, { recipeId: recipeId })"
              on-favourite="$ctrl.toggleFavouriteRecipe({
                memberId: $ctrl.member.id,
                recipeId: $ctrl.recipe.id,
                isFavourite: $ctrl.recipe.isFavourite,
              })">
            </recipe-detail>
          </div>
        </div>
      </main>
    </div>`,

  controller($ngRedux, $timeout) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.unsubscribe = connect(this);

        if (!this.recipe || !this.recipe.id || !this.recipe.nutritionSummary) {
          this.fetchRecipe(this.recipeId);
        }
      },

      $onDestroy() {
        this.unsubscribe();
      },

      refetchMember() {
        this.tooltip && $timeout(() => this.fetchMember(this.member.id), 500);
      },

      mapState({ favourite, member, recipe, router }) {
        const { recipeId } = router.currentParams;
        const { name } = router.currentState;
        const subscription = selectSubscription(member);

        return {
          name,
          recipeId,
          subscription,
          tooltip: selectPrintTooltip(member),
          member: selectMember(member),
          printUri: recipePrintUri(recipeId, subscription.id),
          recipe: mapIsFavouriteRecipes(
            selectRecipe(recipe, recipeId),
            selectFavouriteRecipeIds(favourite)
          ),
        };
      },

      mapDispatch() {
        return {
          fetchMember,
          fetchRecipe,
          stateGo,
          toggleFavouriteRecipe,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Recipe.js